/* eslint-disable @typescript-eslint/naming-convention */
enum GraphClientNames {
    'bestone-bi4-buying-style-bff' = 'STYLEBFF',
    'bestone-bi4-buying-bom-bff' = 'BOMBFF',
    'bestone-bi4-buying-basic-data-bff' = 'BASICDATABFF',
    'bestone-bi4-buying-user-bff' = 'USER-BFF',
    'bestone-bi4-buying-order-bff' = 'ORDERBFF',
    'bestone-bi4-buying-comm-service' = 'COMM-SERVICE',
    'bestone-bi2-buying-reports' = 'REPORTS',
    'bestone-bi4-buying-ext-composition-bff' = 'EXTENDEDCOMPOSITIONBFF',
    'bestone-bi4-buying-order-core' = 'ORDERCORE',
    'bestone-bi4-buying-colour-core' = 'COLOURCORE',
    'bestone-bi4-buying-style-core' = 'STYLECORE',
    'bestone-bi4-buying-basicdata-core' = 'BASICDATACORE',
}

export { GraphClientNames };
